export type Locale = "zh-Hant" | "en" | "ja";

const en = {
  close: "Close",
  done: "Done",
  expandNavigation: "Expand navigation",
  collapseNavigation: "Collapse navigation",
  noSavedSessions: "No saved sessions yet.",
  chooseSavedSession:
    "Choose a saved session to continue reviewing its images.",
  savedSessions: "Saved sessions",
  generatedSessionsHint:
    "Your generated image sessions will appear here after you create them.",
  previewPrompts: "Preview prompts",
  preparingPrompts: "Preparing prompts…",
  compiledPromptPreview: "Compiled prompt preview ({count} slots)",
  exportImages: "Export",
  savedBatches: "Saved batches ({count})",
  batchComplete: "Complete",
  batchFailed: "Failed",
  batchInProgress: "In progress",
  loginIdentifier: "User ID or email",
  loginPassword: "Password",
  loginPending: "Logging in…",
  loginInvalid: "Incorrect user ID, email, or password.",
  loginUnavailable: "Unable to sign in. Please try again.",
  workspace: "Workspace",
  pricing: "Pricing",
  login: "Log in",
  logout: "Log out",
  setup: "Prepare product",
  plan: "Confirm image plan",
  review: "Generate & edit",
  setupDetail: "Upload product and choose a platform",
  planDetail: "Shape the 10-image strategy",
  reviewDetail: "Review and refine each image",
  productTitle: "Let’s get to know your product",
  productSubtitle:
    "Add product photos and choose a marketplace. Picasso will plan the rest.",
  addPhoto: "Add product photos",
  useDemoProduct: "Use demo product",
  changePhoto: "Replace product photos",
  productName: "Product name",
  productPlaceholder: "e.g. Wireless noise-cancelling headphones",
  marketplace: "Target marketplace",
  platformSet: "Platform image set · 10 editable images",
  planButton: "Let Picasso plan 10 images",
  assistant: "PICASSO ASSISTANT",
  aiSuggestion: "AI suggestion",
  facts: "Confirmed product facts",
  waitingFacts:
    "AI has identified product traits — waiting for your confirmation.",
  loginRequired: "Log in to generate images.",
  loginTitle: "Welcome to Narrates",
  loginSubtitle:
    "Create, publish, and learn from product listings with Picasso.",
  logoutTitle: "You’re logged out",
  logoutSubtitle: "Your session has ended and your workspace is secure.",
  logoutRedirect: "Returning to the main page in 3 seconds…",
  logoutNow: "Return now",
  email: "Email address",
  continue: "Continue",
  continueWithEmail: "Continue with email",
  loginPrivacy: "This demo stores your session only in this browser.",
  plansTitle: "A flexible launch plan for your commerce operation",
  plansSubtitle:
    "Choose your starting capacity. Narrates configures final coverage with your team.",
  free: "Pilot",
  pro: "Growth",
  business: "Scale",
  month: "/ month",
  startFree: "Start demo",
  choosePro: "Configure with us",
  contactUs: "Talk to us",
  pricingFlexible:
    "Launch pricing is configured with Narrates. All estimates are in USD.",
  listings: "Listings",
  connections: "Connections",
  billing: "Billing & usage",
  usage: "Usage",
  marketplaceConnections: "Marketplace connections",
  amazonJapan: "Amazon Japan",
  connectAmazon: "Connect Amazon Japan",
  connected: "Connected",
  disconnected: "Not connected",
  connectionSubtitle:
    "Authorise Picasso through Seller Central. Picasso never asks for your Amazon API secret.",
  connectDemoAccount: "Connect demo account",
  authorizedAccount: "Authorised seller account",
  connectionReady:
    "Amazon Japan is ready for listing drafts and direct publishing.",
  newListing: "New Amazon listing",
  listingSubtitle:
    "Complete the commercial details, attach selected Picasso images, then choose how to release.",
  sku: "Seller SKU",
  listingTitle: "Listing title",
  brand: "Brand",
  category: "Product category",
  price: "Price (JPY)",
  quantity: "Available quantity",
  description: "Product description",
  fulfilment: "Fulfilment",
  fulfilmentFba: "Fulfilled by Amazon (FBA)",
  fulfilmentFbm: "Fulfilled by merchant (FBM)",
  fbaDescription: "Amazon stores, picks, packs, and ships this product.",
  fbmDescription: "Your team ships orders and manages handling time.",
  imageSet: "Picasso image set",
  imagesAttached: "10 approved image slots attached",
  saveDraft: "Save draft in Seller Central",
  publishNow: "Publish now",
  directPublishConfirm: "Confirm direct publish",
  directPublishWarning:
    "This sends the validated listing to the connected Amazon Japan seller account. Review commercial details carefully.",
  cancel: "Cancel",
  confirmPublish: "Yes, publish listing",
  validation: "Pre-flight validation",
  validationReady: "Ready to release",
  validationMissing: "Complete required listing details to continue",
  listingHistory: "Listing history",
  noListings: "No listings have been created yet.",
  draftSaved: "Draft saved",
  published: "Published",
  publishMode: "Release mode",
  draftMode: "Draft",
  directMode: "Direct publish",
  directModeDescription:
    "Publish to your connected seller account after confirmation.",
  draftModeDescription: "Create a listing draft for review in Seller Central.",
  billingTitle: "Plan your Picasso capacity",
  billingSubtitle:
    "Start with one market and expand channels when the workflow proves useful.",
  monthly: "Monthly",
  annual: "Annual",
  planConfiguration: "Launch configuration",
  visualCredits: "Visual credits",
  visualCreditsDescription:
    "One credit represents one generated or regenerated image. Final billing is agreed with Narrates.",
  markets: "Markets",
  channels: "Channels",
  addMarket: "Add market",
  addChannel: "Add channel",
  included: "Included",
  configured: "Configured",
  creditsUsed: "credits used",
  capacity: "Capacity",
  currentPlan: "Current plan",
  pricingContact: "Request a tailored plan",
  priceOnRequest: "Price on request",
  usdOnly: "USD estimates only",
  generate: "Generate images",
  generating: "Generating",
  regenerate: "Regenerate this image",
  approve: "Approve image",
  approved: "Approved",
  pending: "Needs review",
  selectImage: "Select an image",
  changeBackground: "Change background",
  adjustLighting: "Adjust lighting",
  changeCopy: "Change text",
  changeComposition: "Change composition",
  changeRequest: "Tell Picasso what to adjust",
  quickAdjustments: "Quick adjustments",
  preserveProduct: "Product facts to preserve",
  productShape: "Product shape",
  productColour: "Product colour",
  brandMark: "Brand mark",
  packagingText: "Packaging text",
  creativeDirection: "Creative direction",
  allImages: "All images",
  selectedImages: "Selected images",
  restoreAll: "Restore all",
  addImage: "Add an image",
  imagePurpose: "Image purpose",
  visualDirection: "Visual direction",
  whyThisImage: "Why this image",
  moveUp: "Move up",
  moveDown: "Move down",
  remove: "Remove",
  restore: "Restore",
  noDirection: "Let Picasso decide",
  publishGuard: "Connect Amazon Japan before publishing a listing.",
  required: "Required",
  optional: "Optional",
  demoOnly: "Demo mode",
  publishedReference: "Listing reference",
  activity: "Activity",
  sellerCentralDraft: "Seller Central draft",
  listingPublished: "Listing published",
  backToWorkspace: "Back to workspace",
  productPhotoAlt: "Added black wireless headphones",
  noNotifications: "No new notifications",
  referenceTitle: "Creative References",
  referenceHelp:
    "Upload photos that inspire style, layout, color, lighting, composition, or setting. They guide the AI but will not appear in final images.",
  addReference: "Add Reference Photo",
  role_style: "Style",
  role_layout: "Layout",
  role_color: "Color",
  role_lighting: "Lighting",
  role_composition: "Composition",
  role_context: "Context",
  photoGuidance:
    "Upload 1–8 product photos from different angles for a more faithful result.",
  detectedFacts: "AI has identified the product shape and four traits",
  confirmFacts:
    "Confirm these product facts before Picasso uses them: black over-ear headphones · foldable earcups · wireless connectivity · visible brand mark",
  confirm: "Confirm",
  platformDecision: "Sets the output format and recommendations",
  selectMarket: "Choose a market",
  selectPlatform: "Choose a platform",
  platformPlanning:
    "Picasso will use the selected platform placement to plan an image set you can adjust image by image.",
  emptyPlanTitle: "Your image plan is empty",
  emptyPlanSubtitle:
    "Restore Picasso’s ten suggestions, then keep only the assets your listing needs.",
  restoreTen: "Restore all 10 images",
  planTitle: "Every image in this set has a job",
  planSubtitle:
    "Picasso proposed this complete set for {platform}. Keep, remove, reorder, or refine each image.",
  selectedCount: "{count} of 10 selected",
  adjusting: "Adjusting",
  protectInstructions: "Product details to preserve",
  imageNote: "Extra direction for this image",
  imageNotePlaceholder: "e.g. Do not show a person; keep the background white",
  creativeDirectionHint: "Optional",
  planAdvice:
    "This is a creative recommendation. You can control each result without remaking the whole set.",
  generateCount: "Generate {count} editable images",
  imagesPreparing: "Images are getting ready",
  reviewTitle: "This image set is ready for your decision",
  reviewProgress:
    "{approved} of {total} confirmed. Select one image to change only it.",
  previousImage: "Previous image",
  nextImage: "Next image",
  onlyThisImage: "Only this image",
  version: "Version",
  generationProtection: "Protection instructions for this generation",
  protectionNote:
    "These are instructions for AI. Check the actual result after generation.",
  photoRequired: "Upload photos to see this section.",
  assistantSetupTitle: "I’ll organise the product essentials first",
  assistantPlanTitle: "This is an adjustable recommendation",
  assistantReviewTitle: "Refine each result until it is useful",
  assistantSetupAdvice:
    "Once you add product photos, I’ll separate recognised product facts from the details that need your confirmation.",
  assistantPlanAdvice:
    "Keep “{purpose}” — it helps customers understand the product at a glance.",
  assistantReviewAdvice:
    "You are reviewing “{purpose}”. Changing this image will not affect the rest of the set.",
  mainNavigation: "Main navigation",
  help: "Help",
  notifications: "Notifications",
  decreaseImageCount: "Decrease image count",
  increaseImageCount: "Increase image count",
  themeLight: "Light theme",
  themeDark: "Dark theme",
  themeToggle: "Toggle theme",
};

export type TranslationKey = keyof typeof en;
const zh: Record<TranslationKey, string> = {
  close: "關閉",
  done: "完成",
  expandNavigation: "展開導覽",
  collapseNavigation: "收起導覽",
  noSavedSessions: "尚未儲存任何圖片工作階段。",
  chooseSavedSession: "選擇已儲存的工作階段，繼續審核圖片。",
  savedSessions: "已儲存的工作階段",
  generatedSessionsHint: "生成圖片後，圖片工作階段會顯示在這裡。",
  previewPrompts: "預覽提示詞",
  preparingPrompts: "正在準備提示詞……",
  compiledPromptPreview: "已編譯的提示詞預覽（{count} 張圖片）",
  exportImages: "匯出",
  savedBatches: "已儲存的圖片批次（{count}）",
  batchComplete: "已完成",
  batchFailed: "失敗",
  batchInProgress: "處理中",
  loginIdentifier: "使用者 ID 或電郵",
  loginPassword: "密碼",
  loginPending: "登入中……",
  loginInvalid: "使用者 ID、電郵或密碼不正確。",
  loginUnavailable: "無法登入，請稍後再試。",
  workspace: "創作工作區",
  pricing: "方案",
  login: "登入",
  logout: "登出",
  setup: "準備商品",
  plan: "確認圖片方案",
  review: "生成與修改",
  setupDetail: "上載產品與選擇平台",
  planDetail: "調整 10 張圖片策略",
  reviewDetail: "逐張審核與優化",
  productTitle: "先讓我們認識你的商品",
  productSubtitle: "加入產品照片，選好銷售平台；其餘的，我們會先替你規劃好。",
  addPhoto: "加入產品照片",
  useDemoProduct: "使用示範商品",
  changePhoto: "更換產品照片",
  productName: "商品名稱",
  productPlaceholder: "例如：無線降噪頭戴式耳機",
  marketplace: "目標銷售市場",
  platformSet: "平台圖片套組 · 10 張可編輯",
  planButton: "由 Picasso 規劃 10 張圖片",
  assistant: "PICASSO 助手",
  aiSuggestion: "AI 建議",
  facts: "已確認的商品事實",
  waitingFacts: "AI 已識別特徵，正等待你確認。",
  loginRequired: "請先登入，才可生成圖片。",
  loginTitle: "登入 Narrates",
  loginSubtitle: "以 Picasso 建立、發佈並持續優化商品頁。",
  logoutTitle: "你已登出",
  logoutSubtitle: "工作階段已結束，你的工作區現已安全。",
  logoutRedirect: "3 秒後返回主頁……",
  logoutNow: "立即返回",
  email: "電郵地址",
  continue: "繼續",
  continueWithEmail: "使用電郵繼續",
  loginPrivacy: "此示範只會在這個瀏覽器儲存你的工作階段。",
  plansTitle: "為你的電商團隊配置合適的起步方案",
  plansSubtitle: "先選擇所需容量，最終服務範圍由 Narrates 與你的團隊共同配置。",
  free: "試用",
  pro: "成長",
  business: "擴展",
  month: "/ 月",
  startFree: "開始示範",
  choosePro: "與我們配置",
  contactUs: "聯絡我們",
  pricingFlexible: "Launch 價格由 Narrates 與你配置；所有估算均以美元顯示。",
  listings: "商品列表",
  connections: "連接",
  billing: "用量與方案",
  usage: "用量",
  marketplaceConnections: "銷售平台連接",
  amazonJapan: "Amazon 日本",
  connectAmazon: "連接 Amazon 日本",
  connected: "已連接",
  disconnected: "尚未連接",
  connectionSubtitle:
    "透過 Seller Central 授權 Picasso；Picasso 不會要求你的 Amazon API 密鑰。",
  connectDemoAccount: "連接示範帳戶",
  authorizedAccount: "已授權的賣家帳戶",
  connectionReady: "Amazon 日本已可用於建立草稿及直接發佈。",
  newListing: "建立 Amazon 商品頁",
  listingSubtitle: "填妥商業資料、附上已選 Picasso 圖片，然後選擇發佈方式。",
  sku: "賣家 SKU",
  listingTitle: "商品標題",
  brand: "品牌",
  category: "商品類別",
  price: "售價（日圓）",
  quantity: "可售數量",
  description: "商品描述",
  fulfilment: "履約方式",
  fulfilmentFba: "由 Amazon 配送（FBA）",
  fulfilmentFbm: "由賣家配送（FBM）",
  fbaDescription: "Amazon 儲存、揀貨、包裝及寄出此商品。",
  fbmDescription: "你的團隊負責寄貨及處理時間。",
  imageSet: "Picasso 圖片組",
  imagesAttached: "已附上 10 個核准圖片欄位",
  saveDraft: "儲存為 Seller Central 草稿",
  publishNow: "立即發佈",
  directPublishConfirm: "確認直接發佈",
  directPublishWarning:
    "系統會把已驗證的商品頁傳送至已連接的 Amazon 日本賣家帳戶，請仔細核對商業資料。",
  cancel: "取消",
  confirmPublish: "確認發佈商品頁",
  validation: "發佈前檢查",
  validationReady: "可發佈",
  validationMissing: "請完成必要商品資料後再繼續",
  listingHistory: "商品頁紀錄",
  noListings: "尚未建立任何商品頁。",
  draftSaved: "草稿已儲存",
  published: "已發佈",
  publishMode: "發佈方式",
  draftMode: "草稿",
  directMode: "直接發佈",
  directModeDescription: "確認後直接發佈到已連接的賣家帳戶。",
  draftModeDescription: "在 Seller Central 建立草稿，供你稍後檢視。",
  billingTitle: "規劃你的 Picasso 容量",
  billingSubtitle: "先以一個市場開始，待流程證實有效後再擴展平台。",
  monthly: "月繳",
  annual: "年繳",
  planConfiguration: "Launch 配置",
  visualCredits: "圖片額度",
  visualCreditsDescription:
    "一個額度代表一張生成或重新生成的圖片；最終收費由 Narrates 與你協定。",
  markets: "市場",
  channels: "平台",
  addMarket: "增加市場",
  addChannel: "增加平台",
  included: "已包括",
  configured: "已配置",
  creditsUsed: "已用額度",
  capacity: "容量",
  currentPlan: "目前方案",
  pricingContact: "索取度身方案",
  priceOnRequest: "報價洽詢",
  usdOnly: "只顯示美元估算",
  generate: "生成圖片",
  generating: "生成中",
  regenerate: "只重新生成這張圖片",
  approve: "核准圖片",
  approved: "已核准",
  pending: "待審核",
  selectImage: "選擇圖片",
  changeBackground: "更換背景",
  adjustLighting: "調整光線",
  changeCopy: "修改文字",
  changeComposition: "更換構圖",
  changeRequest: "告訴 Picasso 你想調整甚麼",
  quickAdjustments: "快速調整",
  preserveProduct: "必須保留的商品事實",
  productShape: "商品外形",
  productColour: "商品顏色",
  brandMark: "品牌標誌",
  packagingText: "包裝文字",
  creativeDirection: "創作方向",
  allImages: "所有圖片",
  selectedImages: "已選圖片",
  restoreAll: "恢復全部",
  addImage: "加入圖片",
  imagePurpose: "圖片用途",
  visualDirection: "視覺方向",
  whyThisImage: "這張圖片的原因",
  moveUp: "上移",
  moveDown: "下移",
  remove: "移除",
  restore: "還原",
  noDirection: "交由 Picasso 決定",
  publishGuard: "請先連接 Amazon 日本，才可發佈商品頁。",
  required: "必填",
  optional: "選填",
  demoOnly: "示範模式",
  publishedReference: "商品頁編號",
  activity: "活動紀錄",
  sellerCentralDraft: "Seller Central 草稿",
  listingPublished: "商品頁已發佈",
  backToWorkspace: "回到工作區",
  productPhotoAlt: "已加入的黑色無線頭戴式耳機",
  noNotifications: "沒有新通知",
  referenceTitle: "創意參考",
  referenceHelp:
    "上傳啟發風格、版面、色彩、光線、構圖或場景的照片。這些將引導 AI，但不會出現在最終圖像中。",
  addReference: "加入參考照片",
  role_style: "風格",
  role_layout: "版面",
  role_color: "色彩",
  role_lighting: "光線",
  role_composition: "構圖",
  role_context: "場景",
  photoGuidance: "可上載 1–8 張不同角度的商品照片，讓結果更貼近實物。",
  detectedFacts: "AI 已識別出產品外形與 4 項特徵",
  confirmFacts:
    "請確認後才會作為產品事實：黑色頭戴式耳機 · 可摺疊耳罩 · 無線連接 · 品牌標誌清晰可見",
  confirm: "確認",
  platformDecision: "決定格式與建議",
  selectMarket: "選擇市場",
  selectPlatform: "選擇平台",
  platformPlanning:
    "Picasso 會依所選平台的素材位置，規劃可逐張調整的圖片方案。",
  emptyPlanTitle: "這組圖片方案目前是空的",
  emptyPlanSubtitle:
    "你可以還原 Picasso 的十張建議，再從中保留真正需要的素材。",
  restoreTen: "還原全部 10 張圖片",
  planTitle: "這 10 張圖片，各有一個工作",
  planSubtitle:
    "Picasso 已按 {platform} 建議完整圖組。可保留、移除、排序或逐張調整。",
  selectedCount: "已選擇 {count} / 10",
  adjusting: "正在調整",
  protectInstructions: "交給 Picasso 的保護指示",
  imageNote: "這張圖的補充說明",
  imageNotePlaceholder: "例如：不要出現人物，保持白色背景",
  creativeDirectionHint: "選填",
  planAdvice: "這是創作建議；你可以逐張控制結果，無需重做整組圖片。",
  generateCount: "生成 {count} 張可編輯圖片",
  imagesPreparing: "圖片正在準備中",
  reviewTitle: "這組圖片已準備好讓你逐張決定",
  reviewProgress: "{approved} / {total} 張已確認。選一張圖片，只修改它。",
  previousImage: "上一張",
  nextImage: "下一張",
  onlyThisImage: "只改這張",
  version: "版本",
  generationProtection: "本次生成的保護指示",
  protectionNote: "這些是提供給 AI 的保護指示；請在生成後核對實際結果。",
  photoRequired: "上載照片後才會顯示。",
  assistantSetupTitle: "我會先整理商品重點",
  assistantPlanTitle: "這是一組可調整的建議",
  assistantReviewTitle: "逐張把結果修到可用",
  assistantSetupAdvice:
    "加入產品照片後，我會分辨已識別的產品事實與需要你確認的內容。",
  assistantPlanAdvice: "建議保留「{purpose}」，它能幫助顧客在第一眼理解商品。",
  assistantReviewAdvice:
    "目前正在查看「{purpose}」。只修改這張圖，不會影響其餘成品。",
  mainNavigation: "主選單",
  help: "說明",
  notifications: "通知",
  decreaseImageCount: "減少圖片數量",
  increaseImageCount: "增加圖片數量",
  themeLight: "淺色主題",
  themeDark: "深色主題",
  themeToggle: "切換主題",
};

const ja: Record<TranslationKey, string> = {
  close: "閉じる",
  done: "完了",
  expandNavigation: "ナビゲーションを展開",
  collapseNavigation: "ナビゲーションを折りたたむ",
  noSavedSessions: "保存済みのセッションはまだありません。",
  chooseSavedSession:
    "保存済みのセッションを選択して、画像の確認を続けてください。",
  savedSessions: "保存済みセッション",
  generatedSessionsHint:
    "画像を生成すると、そのセッションがここに表示されます。",
  previewPrompts: "プロンプトをプレビュー",
  preparingPrompts: "プロンプトを準備中…",
  compiledPromptPreview: "コンパイル済みプロンプト（{count} 枚）",
  exportImages: "エクスポート",
  savedBatches: "保存済みバッチ（{count}）",
  batchComplete: "完了",
  batchFailed: "失敗",
  batchInProgress: "処理中",
  loginIdentifier: "ユーザーIDまたはメールアドレス",
  loginPassword: "パスワード",
  loginPending: "ログイン中…",
  loginInvalid:
    "ユーザーID、メールアドレス、またはパスワードが正しくありません。",
  loginUnavailable: "ログインできません。もう一度お試しください。",
  workspace: "ワークスペース",
  pricing: "料金",
  login: "ログイン",
  logout: "ログアウト",
  setup: "商品を準備",
  plan: "画像プランを確認",
  review: "生成・編集",
  setupDetail: "商品をアップロードしてプラットフォームを選択",
  planDetail: "10枚の画像戦略を調整",
  reviewDetail: "画像ごとに確認・改善",
  productTitle: "まず商品を教えてください",
  productSubtitle:
    "商品写真と販売先を選択してください。残りは Picasso が計画します。",
  addPhoto: "商品写真を追加",
  useDemoProduct: "デモ商品を使う",
  changePhoto: "商品写真を変更",
  productName: "商品名",
  productPlaceholder: "例：ワイヤレスノイズキャンセリングヘッドホン",
  marketplace: "対象マーケット",
  platformSet: "プラットフォーム画像セット・10枚を編集可能",
  planButton: "Picasso に10枚を計画させる",
  assistant: "PICASSO アシスタント",
  aiSuggestion: "AIの提案",
  facts: "確認済みの商品情報",
  waitingFacts: "AI が商品特徴を認識しました。確認をお待ちしています。",
  loginRequired: "画像を生成するにはログインしてください。",
  loginTitle: "Narrates にログイン",
  loginSubtitle: "Picasso で商品ページを作成、公開、継続的に改善します。",
  logoutTitle: "ログアウトしました",
  logoutSubtitle: "セッションが終了し、ワークスペースは安全です。",
  logoutRedirect: "3秒後にメインページへ戻ります…",
  logoutNow: "今すぐ戻る",
  email: "メールアドレス",
  continue: "続ける",
  continueWithEmail: "メールで続ける",
  loginPrivacy: "このデモはブラウザ内にのみセッションを保存します。",
  plansTitle: "コマース運用に合わせた開始プラン",
  plansSubtitle:
    "最初の容量を選び、最終的な利用範囲は Narrates と一緒に設定します。",
  free: "パイロット",
  pro: "グロース",
  business: "スケール",
  month: "/ 月",
  startFree: "デモを始める",
  choosePro: "相談して設定",
  contactUs: "お問い合わせ",
  pricingFlexible:
    "ローンチ価格は Narrates と設定します。すべての見積りは米ドルです。",
  listings: "商品一覧",
  connections: "接続",
  billing: "利用状況とプラン",
  usage: "利用状況",
  marketplaceConnections: "マーケットプレイス接続",
  amazonJapan: "Amazon 日本",
  connectAmazon: "Amazon Japan を接続",
  connected: "接続済み",
  disconnected: "未接続",
  connectionSubtitle:
    "Seller Central を通じて Picasso を認可します。Picasso が Amazon API シークレットを求めることはありません。",
  connectDemoAccount: "デモアカウントを接続",
  authorizedAccount: "認可済み販売事業者アカウント",
  connectionReady: "Amazon Japan で下書き作成と直接公開を利用できます。",
  newListing: "Amazon 商品ページを作成",
  listingSubtitle:
    "販売情報を入力し、選択した Picasso 画像を添付して、公開方法を選択します。",
  sku: "出品者 SKU",
  listingTitle: "商品タイトル",
  brand: "ブランド",
  category: "商品カテゴリー",
  price: "価格（円）",
  quantity: "販売可能数",
  description: "商品説明",
  fulfilment: "フルフィルメント",
  fulfilmentFba: "Amazon が発送（FBA）",
  fulfilmentFbm: "出品者が発送（FBM）",
  fbaDescription: "Amazon が保管、梱包、発送を行います。",
  fbmDescription: "あなたのチームが発送と出荷準備時間を管理します。",
  imageSet: "Picasso 画像セット",
  imagesAttached: "承認済みの画像枠 10 件を添付",
  saveDraft: "Seller Central に下書きを保存",
  publishNow: "今すぐ公開",
  directPublishConfirm: "直接公開を確認",
  directPublishWarning:
    "検証済みの商品ページを接続済みの Amazon Japan 販売事業者アカウントに送信します。販売情報をよく確認してください。",
  cancel: "キャンセル",
  confirmPublish: "商品ページを公開する",
  validation: "公開前チェック",
  validationReady: "公開できます",
  validationMissing: "続行するには必須の商品情報を入力してください",
  listingHistory: "商品ページ履歴",
  noListings: "まだ商品ページは作成されていません。",
  draftSaved: "下書きを保存しました",
  published: "公開済み",
  publishMode: "公開方法",
  draftMode: "下書き",
  directMode: "直接公開",
  directModeDescription:
    "確認後、接続済みの販売事業者アカウントに直接公開します。",
  draftModeDescription: "Seller Central で確認できる下書きを作成します。",
  billingTitle: "Picasso の利用容量を計画",
  billingSubtitle:
    "まず一つの市場から始め、効果が確認できたらチャネルを拡大します。",
  monthly: "月払い",
  annual: "年払い",
  planConfiguration: "ローンチ設定",
  visualCredits: "ビジュアルクレジット",
  visualCreditsDescription:
    "1クレジットは1枚の生成または再生成画像です。最終請求は Narrates と協議して決定します。",
  markets: "市場",
  channels: "チャネル",
  addMarket: "市場を追加",
  addChannel: "チャネルを追加",
  included: "含まれる",
  configured: "設定済み",
  creditsUsed: "使用済みクレジット",
  capacity: "容量",
  currentPlan: "現在のプラン",
  pricingContact: "個別プランを相談",
  priceOnRequest: "要見積り",
  usdOnly: "米ドル見積りのみ",
  generate: "画像を生成",
  generating: "生成中",
  regenerate: "この画像だけを再生成",
  approve: "画像を承認",
  approved: "承認済み",
  pending: "要確認",
  selectImage: "画像を選択",
  changeBackground: "背景を変更",
  adjustLighting: "光を調整",
  changeCopy: "テキストを変更",
  changeComposition: "構図を変更",
  changeRequest: "Picasso への変更依頼を入力",
  quickAdjustments: "クイック調整",
  preserveProduct: "保持する商品情報",
  productShape: "商品形状",
  productColour: "商品カラー",
  brandMark: "ブランドマーク",
  packagingText: "パッケージの文字",
  creativeDirection: "クリエイティブの方向",
  allImages: "すべての画像",
  selectedImages: "選択済み画像",
  restoreAll: "すべて復元",
  addImage: "画像を追加",
  imagePurpose: "画像の役割",
  visualDirection: "ビジュアル方向",
  whyThisImage: "この画像の理由",
  moveUp: "上へ",
  moveDown: "下へ",
  remove: "削除",
  restore: "復元",
  noDirection: "Picasso に任せる",
  publishGuard: "商品ページを公開する前に Amazon Japan を接続してください。",
  required: "必須",
  optional: "任意",
  demoOnly: "デモモード",
  publishedReference: "商品ページ参照番号",
  activity: "アクティビティ",
  sellerCentralDraft: "Seller Central 下書き",
  listingPublished: "商品ページを公開しました",
  backToWorkspace: "ワークスペースに戻る",
  productPhotoAlt: "追加済みの黒いワイヤレスヘッドホン",
  noNotifications: "新しい通知はありません",
  referenceTitle: "クリエイティブリファレンス",
  referenceHelp:
    "スタイル、レイアウト、色、照明、構図、または設定にインスピレーションを与える写真をアップロードします。これらはAIをガイドしますが、最終画像には表示されません。",
  addReference: "参考写真を追加",
  role_style: "スタイル",
  role_layout: "レイアウト",
  role_color: "カラー",
  role_lighting: "照明",
  role_composition: "構図",
  role_context: "設定",
  photoGuidance:
    "実物に近い結果のため、異なる角度から1～8枚の商品写真を追加できます。",
  detectedFacts: "AI が商品形状と4つの特徴を認識しました",
  confirmFacts:
    "Picasso が商品情報として使用する前に確認してください：黒いオーバーイヤーヘッドホン・折りたたみ式イヤーカップ・ワイヤレス接続・見えるブランドマーク",
  confirm: "確認",
  platformDecision: "出力形式と提案を決定",
  selectMarket: "市場を選択",
  selectPlatform: "プラットフォームを選択",
  platformPlanning:
    "Picasso は選択したプラットフォームの掲載枠を使って、画像ごとに調整できるプランを作成します。",
  emptyPlanTitle: "この画像プランは空です",
  emptyPlanSubtitle:
    "Picasso の10件の提案を復元し、商品ページに必要な素材だけを残せます。",
  restoreTen: "10枚の画像をすべて復元",
  planTitle: "この10枚には、それぞれ役割があります",
  planSubtitle:
    "Picasso が {platform} 向けに完全なセットを提案しました。画像ごとに保持、削除、並べ替え、調整できます。",
  selectedCount: "10枚中 {count} 枚を選択",
  adjusting: "調整中",
  protectInstructions: "Picasso に伝える保護指示",
  imageNote: "この画像への追加指示",
  imageNotePlaceholder: "例：人物は表示せず、背景は白にする",
  creativeDirectionHint: "任意",
  planAdvice:
    "これはクリエイティブ提案です。セット全体を作り直さず、画像ごとに結果を操作できます。",
  generateCount: "編集可能な画像を {count} 枚生成",
  imagesPreparing: "画像を準備しています",
  reviewTitle: "この画像セットは確認の準備ができました",
  reviewProgress:
    "{total} 枚中 {approved} 枚を確認済みです。1枚を選ぶと、その画像だけを編集できます。",
  previousImage: "前の画像",
  nextImage: "次の画像",
  onlyThisImage: "この画像だけ",
  version: "バージョン",
  generationProtection: "今回の生成で保護する情報",
  protectionNote:
    "これは AI への指示です。生成後に実際の結果を確認してください。",
  photoRequired: "写真を追加すると表示されます。",
  assistantSetupTitle: "まず商品の要点を整理します",
  assistantPlanTitle: "これは調整できる提案です",
  assistantReviewTitle: "結果を一枚ずつ使える状態にします",
  assistantSetupAdvice:
    "商品写真を追加すると、認識した商品情報と確認が必要な情報を分けます。",
  assistantPlanAdvice:
    "「{purpose}」を残すことをおすすめします。商品を一目で理解するのに役立ちます。",
  assistantReviewAdvice:
    "「{purpose}」を表示しています。この画像だけを変更しても、他の完成画像には影響しません。",
  mainNavigation: "メインナビゲーション",
  help: "ヘルプ",
  notifications: "通知",
  decreaseImageCount: "画像枚数を減らす",
  increaseImageCount: "画像枚数を増やす",
  themeLight: "ライトテーマ",
  themeDark: "ダークテーマ",
  themeToggle: "テーマを切り替え",
};

export const copy: Record<Locale, Record<TranslationKey, string>> = {
  en,
  "zh-Hant": zh,
  ja,
};
export function t(locale: Locale, key: TranslationKey) {
  return copy[locale][key];
}
export function interpolate(
  value: string,
  values: Record<string, string | number>,
) {
  return value.replace(/\{(\w+)\}/g, (_, key) => String(values[key] ?? ""));
}
const purposes = {
  商品主圖: ["Main image", "商品メイン画像"],
  質感形象圖: ["Brand image", "ブランドイメージ"],
  生活情境圖: ["Lifestyle image", "ライフスタイル画像"],
  細節特寫圖: ["Detail close-up", "ディテール画像"],
  核心賣點圖: ["Key benefit", "主要訴求画像"],
  功能解說圖: ["Feature explainer", "機能説明画像"],
  使用場景圖: ["Use case", "利用シーン画像"],
  配件展示圖: ["Included items", "同梱品画像"],
  尺寸規格圖: ["Specifications", "サイズ・仕様画像"],
  品牌故事圖: ["Brand story", "ブランドストーリー画像"],
} as const;
export function localizePurpose(locale: Locale, purpose: string) {
  const item = purposes[purpose as keyof typeof purposes];
  return item
    ? locale === "en"
      ? item[0]
      : locale === "ja"
        ? item[1]
        : purpose
    : purpose;
}
export function localizePurposeForLocale(locale: Locale, purpose: string) {
  const item = Object.entries(purposes).find(
    ([key, values]) =>
      key === purpose || (values as readonly string[]).includes(purpose),
  );
  return item ? localizePurpose(locale, item[0]) : purpose;
}

export const creativeDirectionDefaults: Record<Locale, string> = {
  "zh-Hant": "精緻、簡約，適合日本消費者。保留產品顏色與品牌標誌。",
  en: "Refined and minimal for Japanese shoppers. Preserve the product colour and brand mark.",
  ja: "日本の消費者向けに、洗練されたミニマルな表現にする。商品の色とブランドマークを保持する。",
};
const directions = {
  "Clean Studio": ["Clean Studio", "クリーンスタジオ"],
  Premium: ["Premium", "プレミアム"],
  Lifestyle: ["Lifestyle", "ライフスタイル"],
  Editorial: ["Editorial", "エディトリアル"],
  "Warm Minimal": ["Warm Minimal", "温かいミニマル"],
  "Macro Detail": ["Macro Detail", "マクロディテール"],
  "Feature Focus": ["Feature Focus", "特徴フォーカス"],
  Explainer: ["Explainer", "説明"],
  "Use Case": ["Use Case", "利用シーン"],
  "Included Items": ["Included Items", "同梱品"],
  Specification: ["Specification", "仕様"],
  "Brand Story": ["Brand Story", "ブランドストーリー"],
} as const;
export function localizeDirection(locale: Locale, direction: string) {
  const item = directions[direction as keyof typeof directions];
  return item ? (locale === "ja" ? item[1] : item[0]) : direction;
}
const rationales = {
  第一眼就辨識到商品: [
    "Recognise the product at a glance",
    "ひと目で商品を認識させる",
  ],
  建立品牌質感與信任: [
    "Build brand quality and trust",
    "ブランド品質と信頼を築く",
  ],
  讓客戶看見使用情境: [
    "Show the customer the usage context",
    "使用シーンを見せる",
  ],
  呈現材質與做工: ["Show material and craftsmanship", "素材と作りを見せる"],
  快速傳達主要好處: [
    "Communicate the main benefit quickly",
    "主要な利点をすばやく伝える",
  ],
  把功能說清楚: ["Explain the feature clearly", "機能を明確に伝える"],
  連結顧客需要: ["Connect to customer needs", "顧客ニーズにつなげる"],
  清楚交代購買內容: ["Make included items clear", "購入内容を明確にする"],
  降低購買不確定感: ["Reduce purchase uncertainty", "購入時の不安を減らす"],
  創造情感差異: ["Create emotional differentiation", "感情的な差別化をつくる"],
} as const;
export function localizeRationale(locale: Locale, rationale: string) {
  const item = rationales[rationale as keyof typeof rationales];
  return item
    ? locale === "en"
      ? item[0]
      : locale === "ja"
        ? item[1]
        : rationale
    : rationale;
}
export const marketLabels: Record<
  Locale,
  Record<"tw" | "jp" | "cn" | "hk", string>
> = {
  "zh-Hant": { tw: "台灣", jp: "日本", cn: "中國", hk: "香港" },
  en: { tw: "Taiwan", jp: "Japan", cn: "Mainland China", hk: "Hong Kong" },
  ja: { tw: "台湾", jp: "日本", cn: "中国", hk: "香港" },
};
const platformNames = {
  "Shopee Taiwan 蝦皮": ["Shopee Taiwan", "Shopee Taiwan（蝦皮）"],
  "momo 購物網": ["momo", "momo ショッピング"],
  "Rakuten Ichiba 樂天市場": ["Rakuten Ichiba", "楽天市場"],
  "Taobao 淘寶": ["Taobao", "タオバオ"],
  "Tmall 天貓": ["Tmall", "Tmall"],
  "JD 京東": ["JD", "JD.com"],
  "Pinduoduo 拼多多": ["Pinduoduo", "Pinduoduo"],
  "Douyin 抖音電商": ["Douyin e-commerce", "Douyin EC"],
  "Taobao Hong Kong 淘寶香港": ["Taobao Hong Kong", "タオバオ香港"],
} as const;
export function localizePlatform(locale: Locale, name: string) {
  const item = platformNames[name as keyof typeof platformNames];
  return item
    ? locale === "en"
      ? item[0]
      : locale === "ja"
        ? item[1]
        : name
    : name;
}
